// *******************************************************************************
// Open Modal
// *******************************************************************************

attachEvent('.image-card--locked-content', 'click', (ev) => {
  const parentElem = ev.target.closest('.sc-magazine-module');
  const magazineModal = parentElem.querySelector('.modal');
  magazineModal.classList.add('is-open-modal');
});
